// When the local cached copy of a remote media file is missing (404), load it
// from its origin server instead. URLs are registered when statuses are
// normalized, and a single capturing listener handles load errors of every
// <img>, <video>, <audio> and <source> in the page.

interface RemoteMediaAttachment {
  url?: string | null;
  preview_url?: string | null;
  remote_url?: string | null;
}

const remoteUrls = new Map<string, string>();

export const registerMediaFallback = (attachment: RemoteMediaAttachment) => {
  const remoteUrl = attachment.remote_url;
  if (!remoteUrl) return;

  [attachment.url, attachment.preview_url].forEach((localUrl) => {
    if (localUrl && localUrl !== remoteUrl) remoteUrls.set(localUrl, remoteUrl);
  });
};

const handleMediaError = (event: Event) => {
  const element = event.target;

  if (
    !(
      element instanceof HTMLImageElement ||
      element instanceof HTMLMediaElement ||
      element instanceof HTMLSourceElement
    )
  )
    return;

  const failedUrl =
    element instanceof HTMLSourceElement
      ? element.src
      : element.currentSrc || element.src;
  // Remote URLs are never keys, so a failing remote does not loop
  const remoteUrl = remoteUrls.get(failedUrl);
  if (!remoteUrl) return;

  if (element instanceof HTMLImageElement) {
    element.removeAttribute('srcset');
    element.src = remoteUrl;
  } else if (element instanceof HTMLSourceElement) {
    element.src = remoteUrl;
    if (element.parentElement instanceof HTMLMediaElement)
      element.parentElement.load();
  } else {
    element.src = remoteUrl;
  }
};

if (typeof document !== 'undefined') {
  // Load errors do not bubble, hence the capture phase
  document.addEventListener('error', handleMediaError, true);
}
